import React from "react";
import { AppBar, Toolbar, Typography } from "@material-ui/core";
import logo from '../logo.svg';

export default () => {
  return (
    <AppBar color="primary">
      <Toolbar position="relative" style={{ display: "flex" }}>
        <Typography style={{ flexGrow: 1, display: 'flex', alignItems: 'center' }}>
          <img width={75} src={logo} alt="Dish Netowork" />
          <div style={{marginLeft: 20}}>Features Generator</div>
        </Typography>
      </Toolbar>
    </AppBar>
  );
};
